import React from 'react';
import quote from '../common/Images/quote.svg';
import unlikeWhite from '../common/Images/thumb_down_white.svg';
import likeWhite from '../common/Images/thumb_up_white.svg';
import unlike from '../common/Images/thumb_down.svg';
import like from '../common/Images/thumb_up.svg';
import error from '../common/Images/Error_icon.svg';

const ChatBotMessage = ({ message, onMessageReaction }) => {
    return (
        <div>
            {message.userId && (
                <div className="min-h-10 text-sf text-sf-dark-500 flex rounded-r-2xl rounded-tl-2xl border mb-2 mr-14 ml-6">
                    <img src={quote} alt="" className="pl-3 pr-2" />
                    <div className="pr-4 pt-2.5 pb-2.5 break-words min-w-0">{message.content}</div>
                </div>
            )}
            {/*Means bot response*/}
            {message.userId === undefined && (
                <div>
                    <div className="text-sf text-sf-dark-500 bg-sf-purple-100 rounded-l-2xl rounded-tr-2xl mr-6 ml-14 mb-2">
                        {message.content && (
                            <div>
                                <div className="border-b border-sf-purple-200 flex justify-between h-10">
                                    <span className="text-sf-light-700 text-sf pb-2.5 pt-2.5 ml-4 pr-2">Answer</span>
                                    {message.reaction === undefined && (
                                        <div className="flex">
                                            <button
                                                className="group"
                                                onClick={() => {
                                                    onMessageReaction(message.id, 'Like');
                                                }}>
                                                <img
                                                    src={likeWhite}
                                                    alt=""
                                                    className="pt-2 pb-2 pr-2 group-hover:hidden"
                                                />
                                                <img
                                                    src={like}
                                                    alt=""
                                                    className=" pt-2 pb-2 pr-2 hidden group-hover:block"
                                                />
                                            </button>
                                            <button
                                                className="group"
                                                onClick={() => {
                                                    onMessageReaction(message.id, 'Dislike');
                                                }}>
                                                <img
                                                    src={unlikeWhite}
                                                    alt=""
                                                    className="pt-2 pb-2 pr-4 group-hover:hidden"
                                                />
                                                <img
                                                    src={unlike}
                                                    alt=""
                                                    className="pt-2 pb-2 pr-4 hidden group-hover:block"
                                                />
                                            </button>
                                        </div>
                                    )}
                                    {message.reaction !== undefined && (
                                        <div className="text-sf-purple-400 text-xxs pb-2.5 pt-2.5 pr-4 w-40">
                                            Thank you for your feedback
                                        </div>
                                    )}
                                </div>
                                <span className="flex pb-4 pt-4 pl-4 pr-4">{message.content}</span>
                            </div>
                        )}
                        {message.error && <span className="flex pb-2 pt-2 pr-4 pl-4">{message.error}</span>}
                    </div>
                    {message.connectionTimeout && (
                        <span className="flex rounded-lg text-sf pb-2.5 pt-2.5 pr-3 pl-3 bg-sf-light-100 mr-6 ml-14 mb-2">
                            <img src={error} alt="" className="pr-2" />
                            {message.connectionTimeout}
                        </span>
                    )}
                </div>
            )}
        </div>
    );
};
export default ChatBotMessage;
